// @ts-nocheck

(function() {
	'use strict'
	
	// ===================================
	// VUE VERFÜGBARKEIT PRÜFEN
	// ===================================

	if (typeof Vue === 'undefined') {
		console.error('❌ Vue.js nicht gefunden - Vue Components werden nicht initialisiert')
		console.log('💡 Stelle sicher, dass Vue.js in vendor files geladen ist')
		return
	}

	console.log('✅ Vue.js verfügbar:', Vue.version || 'Version unbekannt')

	// ===================================
	// ERSATZ FÜR IMPORTS - VENDOR-KOMPATIBEL
	// ===================================

	Vue.config.productionTip = false

	// Ersatz für: import Media from '../../javascripts/bases/media'
	const Media = window.Media || {
		// Breakpoint Definitionen (aus anderen Projektdateien übernommen)
		breakpoints: {
			xs: '26em',    // 416px
			s: '36em',     // 576px  
			m: '52em',     // 832px
			l: '72em',     // 1152px
			xl: '104em'    // 1664px
		},
		
		one: function(condition, callback) {
			const isAbove = condition.startsWith('above-')
			const isBelow = condition.startsWith('below-')
			const breakpoint = condition.replace('above-', '').replace('below-', '')
			
			if (!this.breakpoints[breakpoint]) {
				console.warn(`Breakpoint '${breakpoint}' nicht definiert`)
				callback() // Fallback: führe callback aus
				return
			}
			
			// Erstelle Media Query
			const breakpointValue = this.breakpoints[breakpoint]
			let mediaQuery
			
			if (isAbove) {
				mediaQuery = `(min-width: ${breakpointValue})`
			} else if (isBelow) {
				mediaQuery = `(max-width: ${parseFloat(breakpointValue) - 0.01}em)`
			}
			
			// Prüfe sofort
			if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
				callback()
			}
			
			// Höre auf Änderungen (optional für Resize)
			if (window.matchMedia) {
				const mq = window.matchMedia(mediaQuery)
				const handler = (e) => {
					if (e.matches) callback()
				}
				mq.addListener(handler)
			}
		}
	}

	// Ersatz für: import { query, queryAll } from '../../javascripts/abstract/dom'
	function query(selector, context = document) {
		return context.querySelector(selector)
	}
	function queryAll(selector, context = document) {
		return Array.from(context.querySelectorAll(selector))
	}

	// Ersatz für Vue Komponenten - jetzt global registriert
	const menuDesktop = 'menu-desktop'     // String-Namen für global registrierte Komponenten
	const MenuSidebar = 'menu-sidebar'
	const MenuPhablet = 'menu-phablet'
	const FaktTeaser = 'fakt-teaser'

	// ===================================
	// ORIGINAL CODE - OHNE IMPORT/EXPORT
	// ===================================

	//
	// DESKTOP MENU
	//
	try {
		const desktopMenuVM = new Vue({ render: h => h(menuDesktop) })
		Media.one('above-l', function() {
			const target = document.getElementById('menu-desktop')
			if (target) {
				desktopMenuVM.$mount('#menu-desktop')
				console.log('✅ Desktop Menu mounted')
			} else {
				console.warn('⚠️ #menu-desktop Element nicht gefunden')
			}
		})
	} catch (error) {
		console.error('❌ Desktop Menu Fehler:', error)
	}

	//
	// DESKTOP SIDEBAR
	//
	try {
		const hasSideMenu = 'subPages' in window
		const sidebarMenuVM = new Vue({ render: h => h(MenuSidebar) })
		if (hasSideMenu) {
			Media.one('above-l', function() {
				const target = document.getElementById('menu-sidebar')
				if (target) {
					sidebarMenuVM.$mount('#menu-sidebar')
					console.log('✅ Sidebar Menu mounted')
				} else {
					console.warn('⚠️ #menu-sidebar Element nicht gefunden')
				}
			})
		} else {
			console.log('ℹ️ Sidebar Menu übersprungen (keine subPages)')
		}
	} catch (error) {
		console.error('❌ Sidebar Menu Fehler:', error)
	}

	//
	// PHABLET MENU
	//
	try {
		const phabletMenuVM = new Vue({ render: h => h(MenuPhablet) })
		Media.one('below-l', function() {
			const target = document.getElementById('menu-phablet')
			if (target) {
				phabletMenuVM.$mount('#menu-phablet')
				console.log('✅ Phablet Menu mounted')
			} else {
				console.warn('⚠️ #menu-phablet Element nicht gefunden')
			}
		})
	} catch (error) {
		console.error('❌ Phablet Menu Fehler:', error)
	}

	//
	// SEARCH LAYER
	//
	let searchIsOpen = false
	const searchLayer = query('#search-layer')
	const searchToggles = queryAll('.search-toggle')
	searchToggles.forEach(button => {
		button.addEventListener('click', event => {
			searchIsOpen = !searchIsOpen
			searchLayer.setAttribute('aria-hidden', !searchIsOpen)
			searchToggles.forEach(button => button.setAttribute('aria-expanded', searchIsOpen))
			document.getElementById('tx-indexedsearch-searchbox-sword-layer').focus()
		})
	})

	//
	// FAKT LIST
	//
	try {
		const faktTeasers = queryAll('.teaser-item-fakt')
		if (faktTeasers.length && 'faktList' in window) {
			console.log('✅ Initialisiere', faktTeasers.length, 'Fakt Teasers')
			faktTeasers.forEach(el => {
				const button = el.querySelector('button')
				if (button) {
					const btnLabel = button.getAttribute('aria-label') || 'Mehr erfahren'
					const btnHtml = button.innerHTML || 'Button'
					return new Vue({
						render: h =>
							h(FaktTeaser, {
								props: {
									btnHtml,
									btnLabel,
								},
							}),
					}).$mount(el)
				} else {
					console.warn('⚠️ Button nicht gefunden in Fakt Teaser')
				}
			})
		} else if (faktTeasers.length) {
			console.log('ℹ️ Fakt Teasers gefunden, aber faktList nicht verfügbar')
		}
	} catch (error) {
		console.error('❌ Fakt List Fehler:', error)
	}

	// ===================================
	// EXPORT FÜR EXTERNES ZUGRIFF (OPTIONAL)
	// ===================================

	// Nur exportieren wenn alles funktioniert hat
	if (typeof Vue !== 'undefined') {
		window.VueInstances = window.VueInstances || {}
		
		// Sichere Zuweisung ohne Optional Chaining
		window.VueInstances.desktopMenuVM = window.VueInstances.desktopMenuVM || null
		window.VueInstances.sidebarMenuVM = window.VueInstances.sidebarMenuVM || null
		window.VueInstances.phabletMenuVM = window.VueInstances.phabletMenuVM || null
		
		console.log('✅ Vue Components Setup abgeschlossen')
	}

})() // Ende der IIFE